import React from 'react';
import '../../css/common.css';

export default function Container({ children }) {
  return <div className="container">{children}</div>;
}
